import 'instant.page';
import GTM from '../Components/GTM/GTM';
export default {
	init() {

		let gtmOBJ = new GTM();
		gtmOBJ.init();

		function MobileMenu () {

			var hamburger = document.querySelector('.hamburger');	
			var menu = document.querySelector('.mobileMenu');
			var menuContent = menu.querySelector('.mobileMenu__content');


			hamburger.addEventListener('click', function() {

				if( menu.classList.contains('active') ) {
					hamburger.classList.remove('is-active');
					menu.classList.remove('active');
					document.body.classList.remove('disableScroll');
				} else {
					hamburger.classList.add('is-active');
					menu.classList.add('active');
					document.body.classList.add('disableScroll');
				}

			});

			menu.addEventListener('click',function() {
				hamburger.classList.remove('is-active');
				menu.classList.remove('active');
				document.body.classList.remove('disableScroll');
			});

			menuContent.addEventListener('click',function(e){

				e.stopPropagation();

			});


		}
		MobileMenu();

    	this.headerSubMenu();
    	this.headerHide();
	},
	headerSubMenu() {
		var subMenus = document.querySelectorAll('header .menu__sublist');
		subMenus.forEach( function( menu, index ) {
			menu.querySelectorAll('.content__left a').forEach( function( item, index2 ) {
				item.addEventListener('mouseenter', function() {
					if( menu.querySelector('.right__layout[data-layout="'+item.getAttribute('data-layout')+'"]') ) {
						menu.querySelector('.right__layout[data-layout="'+item.getAttribute('data-layout')+'"]').classList.add('active');
						menu.querySelector('.right__layout[data-layout="default"]').classList.remove('active');
					}
				});
				item.addEventListener('mouseleave', function() {
					if( menu.querySelector('.right__layout[data-layout="'+item.getAttribute('data-layout')+'"]') ) {
						menu.querySelector('.right__layout[data-layout="'+item.getAttribute('data-layout')+'"]').classList.remove('active');
						menu.querySelector('.right__layout[data-layout="default"]').classList.add('active');
					}
				});
			});
		});
	},
	headerHide() {
		var header = document.querySelector('header');
		var lastPosition = 0;

		if( window.scrollY > header.offsetHeight && window.scrollY > lastPosition && !header.classList.contains('hide') ) {
			header.classList.add('hide');
		}
		
		document.addEventListener('scroll', function() {

			if( window.scrollY > header.offsetHeight && window.scrollY > lastPosition && !header.classList.contains('hide') ) {
				header.classList.add('hide');
			}

			if( window.scrollY < lastPosition && header.classList.contains('hide') ) {
				header.classList.remove('hide');
			}
			lastPosition = window.scrollY;

		});
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
